import contentfulGql from 'js/lib/contentfulGql';

import { ctaFragment } from 'bundles/ent-website/queries/common';

export const navParentLinkFragment = contentfulGql`#graphql
  ${ctaFragment}
  fragment EntWebsiteNavParentLink on EntWebsiteNavParentLink {
    sys {
      id
    }
    text
    href
    childrenCollection(limit: 2) {
      items {
        sys {
          id
        }
        heading
        description
        promotion
        linksCollection(limit: 8) {
          items {
            ...Cta
          }
        }
      }
    }
  }
`;

export const entWebsiteNavDomainQuery = contentfulGql`#graphql
  ${ctaFragment}
  ${navParentLinkFragment}
  query entWebsiteNavDomain($domain: String!, $preview: Boolean, $slug: String!, $locale: String!) {
    entWebsiteNavDomainCollection(limit: 1, where:{ domain_contains_some: [$domain] }, preview: $preview, locale: $locale) {
      items {
        title
        domain
        primaryCta {
          ...Cta
        }
        navigationCollection(limit: 6) {
          items {
            ...EntWebsiteNavParentLink
          }
        }
      }
    }
    entWebsitePageAssemblyCollection(where: {slug: $slug}, limit: 1, locale: $locale) {
      items {
        forceHideMetaNav
        customPageHeader {
          logo {
            url
          }
          logoHeight
          logoTarget
          cta {
            ...Cta
          }
          hideMegaMenu
          hideCta
          navigationCollection(limit: 6) {
            items {
              ...EntWebsiteNavParentLink
            }
          }
        }
      }
    }
  }
`;
